var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Status/error-circle/Vector") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Regsiter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Register_OTP_Error4_Expired",
    transform: "translate(-1037.000000, -180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(846.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(141.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83E\\uDDE9-Components/Text-styles/H1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Status/error-circle/Vector",
    transform: "translate(44.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 21.875,
    x2: 35,
    y2: 39.5572917,
    id: "c38ea4ee-07e6-4da8-96d0-09d3823c9d42",
    stroke: "#E60000",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E60000",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 35,
    cy: 35,
    r: 27.7083333
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E60000",
    strokeWidth: 2.5,
    fill: "#E60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 35,
    cy: 46.6666667,
    r: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.3064bfafec5c76cafafec9d000b7316e.svg";
export { ForwardRef as ReactComponent };